import { render, staticRenderFns } from "./AgreementsTablePage.vue?vue&type=template&id=fe9793b2"
import script from "./AgreementsTablePage.vue?vue&type=script&lang=js"
export * from "./AgreementsTablePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports